module.exports = __webpack_public_path__ + "static/media/go_to_link.724ab27f.png";